import { useEffect } from 'react'
import { CallDesktopPanel } from '@/modules/calls/components/CallDesktopPanel'
import { CallOutcomeSheet } from '@/modules/calls/components/CallOutcomeSheet'
import { useCallsEnabled } from '@/modules/calls/hooks/useCalls'
import { callService } from '@/modules/calls/services/call.service'
import { useCallStore } from '@/modules/calls/store/call.store'

/**
 * Mounted once in the app shell. After a tel: call the agent comes back to
 * PMMS — the result form opens by itself on that return.
 */
export function CallHost() {
  const canDial = useCallsEnabled()
  const awaitingId = useCallStore((s) => s.awaitingReturnCallId)
  const openOutcome = useCallStore((s) => s.openOutcome)

  useEffect(() => {
    if (!awaitingId) return
    let hidden = document.visibilityState === 'hidden'
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        hidden = true
        return
      }
      // Only after the dialer actually took over the screen.
      if (!hidden) return
      void callService.clientEvent(awaitingId, 'returned').catch(() => undefined)
      openOutcome(awaitingId)
    }
    document.addEventListener('visibilitychange', onVisibility)
    return () => document.removeEventListener('visibilitychange', onVisibility)
  }, [awaitingId, openOutcome])

  if (!canDial) return null
  return (
    <>
      <CallDesktopPanel />
      <CallOutcomeSheet />
    </>
  )
}
